// TagSelector.jsx
import React, { useState, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Typography, Chip, Button, TextField } from '@mui/material'
import statusStore from '../../../stores/statusStore'

import logger from '../../../utils/logger'

// ... existing code ...
function hexToRgba(hex, alpha = 0.5) {
	let c = hex.replace('#', '')
	if (c.length === 3) {
		c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]
	}
	const r = parseInt(c.slice(0, 2), 16)
	const g = parseInt(c.slice(2, 4), 16)
	const b = parseInt(c.slice(4, 6), 16)
	return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

const TagSelector = observer(({ selectedTags, onChange }) => {
	const [showForm, setShowForm] = useState(false)
	const [tagName, setTagName] = useState('')
	const [tagColor, setTagColor] = useState('#000000')
	const colorInputRef = useRef(null)

	// Функция для проверки, выбран ли тег
	const isSelected = tag => selectedTags.some(t => t.id === tag.id)

	// Обработчик клика по тегу: переключаем состояние выбранного тега
	const handleToggle = tag => {
		if (isSelected(tag)) {
			onChange(selectedTags.filter(t => t.id !== tag.id))
		} else {
			onChange([...selectedTags, tag])
		}
	}

	const handleOpenForm = () => {
		setShowForm(true)
	}

	const handleCancel = () => {
		setTagName('')
		setTagColor('#000000')
		setShowForm(false)
	}

	const handleSave = () => {
		if (!tagName.trim()) {
			alert('Название тега не должно быть пустым')
			return
		}
		
		const newTag = {
			tagName,
			tagColor,
		}
		
		statusStore.addTag(newTag)
		setTagName('')
		setTagColor('#000000')
		setShowForm(false)
	}

	const handleColorChange = e => {
		setTagColor(e.target.value)
	}

	function getMe() {
		logger.log(`selectedTags: ${JSON.stringify(selectedTags)}`)
	}

	return (
		<Box>
			<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
				
				{import.meta.env.VITE_SHOW_COMPONENT_NAME === 'true' && <div onClick={() => logger.log('TagSelector Render')}>% TagSelector %</div>}

				{statusStore.tags.map(tag => {
					const selected = isSelected(tag)
					
					return (
						<Chip
							key={tag.id}
							label={tag.name}
							onClick={() => handleToggle(tag)}
							size="small"
							sx={{
								backgroundColor: selected ? hexToRgba(tag.color, 0.5) : 'transparent',
								border: selected ? `2px solid ${tag.color}` : '1px solid #ccc',
								borderRadius: '12px',
								height: '24px',
								'& .MuiChip-label': {
									fontSize: '0.75rem', 
									padding: '2px 8px',
									lineHeight: 1.2,
								}
							}}
							clickable
						/>
					)
				})}
			
				{!showForm && (
					<Button 
						variant='text' 
						onClick={handleOpenForm} 
						size='small'
						sx={{ textTransform: 'none' }}
					>
						 + Добавить тег
					</Button>
				)}
			</Box>
			
			{showForm && (
				<Box
					sx={{
						maxWidth: 400,
						p: 2,
						border: '1px solid #ccc',
						borderRadius: 1,
						mt: 1
					}}
				>
					<TextField
						fullWidth
						label='Название тега'
						value={tagName}
						onChange={e => setTagName(e.target.value)}
						margin='normal'
						size='small'
					/>

					<Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
						<Box
							sx={{
								width: 30,
								height: 30,
								borderRadius: '50%',
								backgroundColor: tagColor,
								mr: 2,
							}}
						/>
						<Button
							variant='outlined'
							size='small'
							onClick={() => colorInputRef.current.click()}
							sx={{ textTransform: 'none' }}
						>
							Цвет
						</Button>
						<input
							type='color'
							ref={colorInputRef}
							value={tagColor}
							onChange={handleColorChange}
							style={{ display: 'none' }}
						/>
					</Box>

					<Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
						<Button
							variant='outlined'
							onClick={handleCancel}
							sx={{ mr: 1, textTransform: 'none' }}
							size='small'
						>
							Отмена
						</Button>
						<Button 
							variant='contained' 
							onClick={handleSave}
							size='small'
							sx={{ textTransform: 'none' }}
						>
							Сохранить
						</Button>
					</Box>
				</Box>
			)}
		</Box>
	)
})

export default TagSelector
